import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMedia } from 'react-use';
import { Modal, DividerWithLogo, Typography, Icon } from 'ck-ui';
import { TermsAndPrivacyLinks } from 'src/components/TermsAndPrivacyLinks';
import { SignUpForm } from './SignUpForm';
import styles from './PopupSignup.module.scss';

const ConsentPopup = ({
  show,
  onClose,
  heroImage,
  giftImage,
  heading,
  content,
  successHeading,
  successContent,
  campaignId,
}) => {
  const [hasSignedUp, setHasSignedUp] = useState(false);
  const isMobile = useMedia('(max-width: 767px)');

  const handleSignedUp = () => {
    setHasSignedUp(true);
  };

  return (
    <Modal show={show} onClose={onClose} isFixedSize>
      <div className={classnames('is-flex', 'is-full-width', 'is-full-height')}>
        {!isMobile && (
          <div
            className={classnames('is-half-width', styles.image)}
            style={{ backgroundImage: `url('${heroImage}')` }}
          />
        )}

        <div className={classnames(styles.textWrapper, 'is-half-width')}>
          <DividerWithLogo />
          <Typography variant="heading5" align="centered" uppercase>{hasSignedUp ? successHeading : heading}</Typography>
          {hasSignedUp ? (
            <>
              <Typography
                color="black-bis"
                display="block"
                align="centered"
                className={styles.largeMarginTop}
                dangerouslySetInnerHTML={{ __html: successContent }}
              />
              <Typography
                className={classnames(
                  'is-flex',
                  'is-flex-centered',
                  styles.largeMarginTop,
                  styles.largeMarginBottom,
                  styles.tick
                )}
              >
                <Icon color="secondary" name="check" />
              </Typography>
            </>
          ) : (
            <>
              <div className={classnames('is-flex', styles.descriptionWrapper)}>
                {giftImage && (
                  <img
                    src={giftImage}
                    className={classnames(
                      styles.box,
                      styles.marginRight,
                    )}
                    alt="header"
                  />
                )}
                {content && (
                  <Typography
                    color="black-bis"
                    align={giftImage ? 'left' : 'centered'}
                  >
                    {content}
                  </Typography>
                )}
              </div>
              <SignUpForm
                source={campaignId ? 'competition_popup' : 'landing_page_popup'}
                onSubmitSuccess={handleSignedUp}
                campaignId={campaignId}
              />
            </>
          )}
          <TermsAndPrivacyLinks />
        </div>
      </div>
    </Modal>
  );
};

ConsentPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  giftImage: PropTypes.string,
  heroImage: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  successHeading: PropTypes.string.isRequired,
  successContent: PropTypes.string.isRequired,
  campaignId: PropTypes.string,
};

ConsentPopup.defaultProps = {
  campaignId: null,
  giftImage: null,
};

export { ConsentPopup };
